import * as React from "react";
import styled from "react-emotion";
import { theme } from "../../styles/theme";
import { observer, inject } from "mobx-react";
import Link from "gatsby-link";

const Header = styled.div`
  z-index: 1005;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  font-family: ${theme.sans.fontFamily};
  font-weight: 700;
  transform: translateY(${props => (props.open ? "100%" : 0)});
  transition: transform 200ms ease-in;
`;
const Item = styled.div`
  z-index: 1010;
  cursor: pointer;
  padding: ${theme.space2};
`;

const NavFooter = ({ toggleMenu, menuOpen }) => (
  <Header open={menuOpen}>
    <Link to="/work">
      <Item>WORK</Item>
    </Link>
    <Item
      onClick={() => {
        toggleMenu("CONTACT");
      }}
    >
      CONTACT
    </Item>
  </Header>
);
export default inject(({ store }) => ({
  menuOpen: store.appStore.menu.open,
  toggleMenu: store.appStore.toggleMenu
}))(observer(NavFooter));



// WEBPACK FOOTER //
// ./src/components/NavFooter/index.js